import { defineMessages } from 'react-intl';

export const messages: {
	sources_icon_stack_text: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contributors_avatar_stack_text: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	related_links_title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contributors_title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contributors_card_subtitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	show_less_button_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	page_icon_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	globe_icon_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluence_product_name: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	webpage_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contributors_card_hover_profile_link: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	fallback_description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	sources_icon_stack_text: {
		id: 'search_ai.sources_icon_stack_text',
		defaultMessage: '+{count} more',
		description:
			'Text shown in the sources icon stack overflow indicator when there are more sources than can be displayed. The placeholder {count} is substituted with the number of additional sources.',
	},
	contributors_avatar_stack_text: {
		id: 'search_ai.contributors_avatar_stack_text',
		defaultMessage: '+{count} more',
		description:
			'Text shown in the contributors avatar stack overflow indicator when there are more contributors than can be displayed. The placeholder {count} is substituted with the number of additional contributors.',
	},
	related_links_title: {
		id: 'search_ai.related_links_title',
		defaultMessage: 'Related Links',
		description:
			'Section heading shown above the list of related links in the Confluence search result card.',
	},
	contributors_title: {
		id: 'search_ai.contributors_title',
		defaultMessage: 'Collaborators',
		description:
			'Section heading shown above the list of collaborators in the Confluence search result card.',
	},
	contributors_card_subtitle: {
		id: 'search_ai.contributors_card_subtitle',
		defaultMessage: '{type, select, tagged {tagged on this page} other {{type} of this page}}',
		description:
			'Subtitle shown beneath the collaborators heading in the Confluence search result card. The placeholder {type} resolves to the contributor role (e.g., "creator", "contributor"); when the value is "tagged" a distinct phrase is used instead.',
	},
	show_less_button_label: {
		id: 'search_ai.show_less_button_label',
		defaultMessage: 'Show less',
		description:
			'Text shown on the button that collapses an expanded section in the Confluence search result card to show fewer items.',
	},
	page_icon_label: {
		id: 'search_ai.page_icon_label',
		defaultMessage: 'Page Icon',
		description:
			'Accessible label for the page icon shown in the Confluence search result card to indicate the content type is a page.',
	},
	globe_icon_label: {
		id: 'search_ai.globe_icon_label',
		defaultMessage: 'Globe Icon',
		description:
			'Accessible label for the globe icon shown in the Confluence search result card to indicate publicly accessible or web content.',
	},
	confluence_product_name: {
		id: 'search_ai.confluence_product_name',
		defaultMessage: 'Confluence',
		description:
			'Product name label shown in the Confluence search result card to identify that the content originates from Confluence.',
	},
	webpage_label: {
		id: 'search_ai.webpage_label',
		defaultMessage: 'Web page',
		description:
			'Content type label shown in the Confluence search result card when the result is an external web page rather than a Confluence page.',
	},
	contributors_card_hover_profile_link: {
		id: 'search_ai.contributors_card_hover_profile_link',
		defaultMessage: 'View profile',
		description: 'Hover text for contributor card profile link',
	},
	fallback_description: {
		id: 'search_ai.confluence_flex_card_fallback_description',
		defaultMessage: '...{fallbackDescription}...',
		description: 'Fallback description for Confluence flexible card',
	},
});
